export default "__VITE_ASSET__0ecac091__"